import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[100svh] bg-black text-white flex flex-col items-center justify-center px-6 text-center" data-testid="app-error-boundary">
          <img
            src={`${process.env.PUBLIC_URL || ""}/logo-somnium.png`}
            alt="Somnium Group"
            className="w-16 h-16 object-contain mb-8 opacity-90"
            draggable={false}
          />
          <h1 className="font-serif-display text-3xl md:text-4xl mb-4" style={{ letterSpacing: "0.005em" }}>
            Une erreur est survenue.
          </h1>
          <p className="text-white/60 max-w-md mb-10 leading-relaxed">
            Le chargement de cette page a échoué. Rechargez la page ou revenez à l&apos;accueil.
            <br />
            <span className="opacity-70">Something went wrong loading this page. Please reload or return home.</span>
          </p>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-full text-[11px] tracking-[0.28em] uppercase bg-[#e6c98a] text-black hover:bg-white transition-colors"
            >
              Recharger
            </button>
            <a
              href="/"
              className="px-6 py-3 rounded-full text-[11px] tracking-[0.28em] uppercase border border-white/20 text-white/80 hover:border-white/50 hover:text-white transition-colors"
            >
              Accueil
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
